import {Component, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../services/role.service';
import {MatTableGeneratorComponent} from '../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../table-datasouces/multi-crud.datasource';
import {toDateString} from '../../providers/app-date-adapter';
import {PepCheckService} from '../services/pep-check.service';
import {WebIdTransactionPep} from '../../dto/web-id-transaction-pep';
import {AppMatCustomAction} from '../../shared/mat-table-generator/mat-table-core/app-mat-custom-action';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BadgeService} from '../services/badge.service';
import {PepStatus} from '../../dto/pep-status';
import {VeriffPepDetail} from '../../dto/veriff-pep-detail';
import {getIdentStatusColor, getIdentStatusIcon, getIdentStatusText} from '../../helpers/pep-status-helper';
import {ContentRowField} from '../../shared/content-row/content-row.component';

@Component({
  selector: 'app-pep',
  templateUrl: './pep.component.html',
  styleUrls: ['./pep.component.css'],
})
export class PepComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private pepCheckService: PepCheckService,
    private snackBar: MatSnackBar,
    private badgeService: BadgeService,
  ) {
  }

  @ViewChild(MatTableGeneratorComponent, {static: true}) table: MatTableGeneratorComponent;


  pepStatus = PepStatus;

  customActions: any[] = [];
  public status = 'possibleMatches';
  columns = [
    {
      columnDef: 'identifiedOn',
      header: 'Ident Date',
      cell: (row: WebIdTransactionPep) => `${toDateString(row.identifiedOn) || ''}`
    },
    {
      columnDef: 'customer',
      header: 'Customer',
      cell: (row: WebIdTransactionPep) => {
        if( row.customerId != null ){
          return row.customer.firstName + ' ' + row.customer.lastName + ', ' + row.customer.address + ', ' + row.customer.zipCode + ' ' + row.customer.city;
        }else{
          return '123';
        }
      },

    },
    {
      columnDef: 'identStatus',
      header: 'Ident',
      iconColor: row => getIdentStatusColor(row.status) || '',
      icon: row => getIdentStatusIcon(row.status) || '',
      cell: row => getIdentStatusText(row.status) || '',
    } as ContentRowField<WebIdTransactionPep>,
    {
      columnDef: 'bioDataFirstName',
      header: 'Document First Name',
      cell: (row: WebIdTransactionPep) => `${row.bioDataFirstName || ''}`,
    },
    {
      columnDef: 'bioDataLastName',
      header: 'Document Last Name',
      cell: (row: WebIdTransactionPep) => `${row.bioDataLastName || ''}`,
    },
    {
      columnDef: 'bioDataDob',
      header: 'Document Dob',
      cell: (row: WebIdTransactionPep) => `${toDateString(row.bioDataDob) || ''}`
    },
    {
      columnDef: 'pepStatus', header: 'Pep Status', cell: (row: WebIdTransactionPep) => {

      }
    },
    {
      columnDef: 'pepTypes', header: 'Pep Types', cell: (row: WebIdTransactionPep) => {

      }
    },

  ];

  dataSource = new MultiCrudDataSource(this.pepCheckService);

  ngOnInit() {
    this.table.filters.someAdditionalData = this.status;

    this.table.filters.str = this.route.snapshot.queryParamMap.get('search');
    // this.rebuildCustomActions();
    this.table.applyFilter();
  }

  getVerifHitTypeString(type) {
    if( type == null ) {
return '';
}
    if( type == 0 ) {
return '';
}

    if( type == 1 ){
      return 'Adverse Media';
    }
    if( type == 2 ){
      return 'Warning';
    }
    if( type == 4 ){
      return 'PEP';
    }
    if( type == 8 ){
      return 'SIS';
    }

    return '';
  }

  getVerifHitTypeEmoji(type) {
    if( type == null ) {
return '';
}
    if( type == 0 ) {
return '';
}

    if( type == 1 ){
      return '📺';
    }
    if( type == 2 ){
      return '⚠️';
    }
    if( type == 4 ){
      return '🕵🏻';
    }
    if( type == 8 ){
      return '⛔️';
    }

    return '';
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  getVeriffHitTypesStringCombined(veriffPepDetails: VeriffPepDetail[]) {
    if (veriffPepDetails == null) {
      return '';
    }
    const strs = [];

    let hasAdverseMedia = false;
    let hasWarning = false;
    let hasPep = false;
    let hasSis = false;
    veriffPepDetails.forEach(pd => {
      pd.hits.forEach(item => {
        if( (item.hitTypes & 1) != 0 ){
          hasAdverseMedia = true;
        }
        if( (item.hitTypes & 2) != 0 ){
          hasWarning = true;
        }
        if( (item.hitTypes & 4) != 0 ){
          hasPep = true;
        }
        if( (item.hitTypes & 8) != 0 ){
          hasSis = true;
        }
      });
    });

    if( hasAdverseMedia ){
      strs.push('📺 Adverse Media');
    }
    if( hasWarning ){
      strs.push('⚠️ Warning');
    }
    if( hasPep ){
      strs.push('🕵🏻 PEP');
    }
    if( hasSis ){
      strs.push('⛔️ SIS');
    }

    return strs.reverse().join(', ');
  }

  getVeriffHitTypesString(item){
    if (item == null) {
      return '';
    }
    const strs = [];

    if( (item.hitTypes & 1) != 0 ){
      strs.push('📺 Adverse Media');
    }
    if( (item.hitTypes & 2) != 0 ){
      strs.push('⚠️ Warning');
    }
    if( (item.hitTypes & 4) != 0 ){
      strs.push('🕵🏻 PEP');
    }
    if( (item.hitTypes & 8) != 0 ){
      strs.push('⛔️ SIS');
    }

    return strs.join(', ');
  }

  getPepStatusString(row){
    if (row.pepStatus == null) {
      return 'unknown';
    }

    if (row.pepStatus == 0) {
      return 'pending';
    } else if (row.pepStatus == 1) {
      return 'no match';
    } else if (row.pepStatus == 2) {
      return 'possible match';
    } else {
      return 'unknown';
    }
  }

  getIdentStatusString(row){
    if (row.status == null) {
      return 'unknown';
    }

    if (row.status == 0) {
      return 'pending';
    } else if (row.status == 1) {
      return 'success';
    } else if (row.status == 2) {
      return 'fail';
    } else {
      return 'unknown';
    }
  }

  currentUserIsAdminOrCompliance(){
    return this.roleService.hasRoles('admin') || this.roleService.hasRoles('compliance');
  }

  currentUserIsAdminOrComplianceOrFinanceManagerOrManager(): boolean {
    return this.roleService.hasRoles(['admin', 'compliance', 'finance_manager', 'manager']);
  }

  ignorePepMatch(row: WebIdTransactionPep){
      this.pepCheckService.ignore(row.id).subscribe(
          result => {
            this.badgeService.refreshBadge('compliance');
            this.badgeService.refreshBadge('pep');
            this.dataSource.loadData();
            this.showMessage(result);
          },
          err => {
            this.showMessage(err.error.message || err.error || err.message);
          });

  }

  confirmPepMatch(row: WebIdTransactionPep){
      this.pepCheckService.confirmPepMatch(row.id).subscribe(
        result => {
          this.badgeService.refreshBadge('compliance');
          this.badgeService.refreshBadge('pep');
          this.dataSource.loadData();
          this.showMessage(result);
        },
        err => {
          this.showMessage(err.error.message || err.error || err.message);
        });

  }

  rebuildCustomActions() {
    if (this.roleService.hasRoles('admin') || this.roleService.hasRoles('compliance')) {
      this.customActions = [
        new AppMatCustomAction(
          'delete',
          'ignore selected items',
          true,
          (rows: WebIdTransactionPep[]) => this.pepCheckService
            .ignoreMany(rows.map(row => row.id))
            .subscribe(
              result => {
                this.badgeService.refreshBadge('compliance');
                this.badgeService.refreshBadge('pep');
                this.dataSource.loadData();
                this.showMessage(result);
              },
              err => {
                this.showMessage(err.error.message || err.error || err.message);
              }
            ),
          (rows: WebIdTransactionPep[]) => {

            let disabled = false;
            rows.forEach(element => {
              if (element.pepStatus != 2) {
                disabled = true;
              }
            });

            return disabled;
          }
        ),

        new AppMatCustomAction(
          'delete',
          'Ignore',
          false,
          (row: WebIdTransactionPep) => this.pepCheckService
            .ignore(row.id)
            .subscribe(
              result => {
                this.badgeService.refreshBadge('compliance');
                this.badgeService.refreshBadge('pep');
                this.dataSource.loadData();
                this.showMessage(result);


              },
              err => {
                this.showMessage(err.error.message || err.error || err.message);
              }
            ),
          (row: WebIdTransactionPep) => {
            if( row.pepStatus != 2 ) {
return true;
}

            return false;
          }
        ),
      ];
    }
  }

  showMessage(message) {
    this.snackBar.open(message, null, {
      duration: 5000,
      panelClass: ['app-mat-snack-bar']
    });
  }


  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
    }
  }


  currentUserIsAdmin() {
    return this.roleService.hasRoles('admin');
  }

  currentUserIsCompliance(): boolean {
    return this.roleService.hasRoles('compliance');
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  filterStatus(source: number) {
    this.status = (source == 0 ? 'all' : (source == 1 ? 'possibleMatches' : 'done'));
    this.triggerSearch();
  }

  triggerSearch() {
    this.table.filters.someAdditionalData = this.status;
    this.onSearch();
  }
}
